import { render, staticRenderFns } from "./eLearning.vue?vue&type=template&id=33aa0718&scoped=true"
import script from "./eLearning.vue?vue&type=script&lang=js"
export * from "./eLearning.vue?vue&type=script&lang=js"
import style0 from "./eLearning.vue?vue&type=style&index=0&id=33aa0718&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33aa0718",
  null
  
)

export default component.exports